// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"088e6a00","732":"be0b57f8","977":"fb84bbe2"}[chunkId] + ".chunk.js";
};